import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { TopMenu } from "../../components";
import LeftMenuCard from "../templates/LeftMenuCard";
import Category from "../Category";
import Menus from "../Menus";
import News from "../news";
import { userDetails, userLogOut } from "../../utils/auth";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import {
  AddNewsUpdateModal,
  AddNewTagModal,
  DBConnectionModal,
  NewsViewModal,
  SelectTagsModal,
} from "../modal";
import Advertisement from "../advertisement";
import AdvCategory from "../AdvCategory";
import Jobs from "../Jobs";
import JobsCategory from "../JobsCategory";
import Tags from "../Tags";
import SiteMap from "../siteMap";
import LiveFeed from "../liveFeed";
import Comments from "../comments";
import DataWarehouse from "../dataWarehouse";
import GovernmentGazette from "../GovernmentGazette";
import Widget from "../Widget";

const Index = (props) => {
  const { location } = props;
  const { isOpenAddUpdateNewsModal } = useSelector(
    ({ newsReducer }) => newsReducer
  );
  const { isOpenNewsViewModal } = useSelector(({ newsReducer }) => newsReducer);

  const { isOpenCreateTagModal, isOpenSelectTagsModal } = useSelector(
    ({ tagsReducer }) => tagsReducer
  );

  const { isOpenConnectDBModal } = useSelector(
    ({ warehouseReducer }) => warehouseReducer
  );

  const logOut = async (e) => {
    userLogOut();
    props.history.push("/sign-in");
  };

  useEffect(() => {
    const checkSession = async () => {
      const user = userDetails();
      if (!user) {
        props.history.push("/sign-in");
      }
    };
    checkSession();
  }, []);

  return (
    <>
      {isOpenAddUpdateNewsModal && <AddNewsUpdateModal />}
      {isOpenNewsViewModal && <NewsViewModal />}
      {isOpenCreateTagModal && <AddNewTagModal />}
      {isOpenConnectDBModal && <DBConnectionModal />}
      {isOpenSelectTagsModal && <SelectTagsModal />}
      <div className={`admin-wrapper`}>
        <div>
          <TopMenu
            data={{
              size: "sm",
              isLanguage: false,
              isLogo: true,
              isProfile: true,
            }}
            onClickLogOut={async (e) => {
              e.preventDefault();
              await logOut(e);
            }}
          />
        </div>

        <LeftMenuCard />
        <div className="admin-body-wrapper">
          {location.pathname === "/admin/category" && (
            <>
              <Category />
            </>
          )}

          {location.pathname === "/admin/menus" && (
            <>
              <Menus />
            </>
          )}
          {location.pathname === "/admin/news" && (
            <>
              <News />
            </>
          )}
          {location.pathname === "/admin/advertisement" && (
            <>
              <Advertisement />
            </>
          )}
          {location.pathname === "/admin/adv-category" && (
            <>
              <AdvCategory />
            </>
          )}
          {location.pathname === "/admin/jobs" && (
            <>
              <Jobs />
            </>
          )}
          {location.pathname === "/admin/jobs-category" && (
            <>
              <JobsCategory />
            </>
          )}
          {location.pathname === "/admin/tags" && (
            <>
              <Tags />
            </>
          )}
          {location.pathname === "/admin/widgets" && (
            <>
              <Widget />
            </>
          )}
          {location.pathname === "/admin/site-map" && (
            <>
              <SiteMap />
            </>
          )}
          {location.pathname === "/admin/live-feed" && (
            <>
              <LiveFeed />
            </>
          )}
          {location.pathname === "/admin/comments" && (
            <>
              <Comments />
            </>
          )}
          {location.pathname === "/admin/warehouse" && (
            <>
              <DataWarehouse />
            </>
          )}
          {location.pathname === "/admin/gazette" && (
            <>
              <GovernmentGazette />
            </>
          )}
          {/* {location.pathname === "/admin/procurement" && (
            <>
              <ProcurementNotice />
            </>
          )} */}
        </div>
      </div>
    </>
  );
};
export default withRouter(Index);
